import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { UserCog, Tag, CalendarDays, Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import DoctorsManagement from "./DoctorsManagement";
import DoctorPricing from "./DoctorPricing";
import ClinicSchedule from "./ClinicSchedule";

const DoctorsHub = () => {
  const [tab, setTab] = useState("manage");

  const copyScheduleLink = async () => {
    const url = `${window.location.origin}/schedule`;
    try {
      await navigator.clipboard.writeText(url);
      toast.success("تم نسخ الرابط");
    } catch {
      toast.error("فشل النسخ");
    }
  };

  return (
    <div className="space-y-6" dir="rtl">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-[#655dc6]">إدارة الأطباء والأسعار</h1>
          <p className="text-slate-500 mt-1">
            أضف الأطباء وأقسامهم، وتحكم بأسعار خدمات كل طبيب، وحدّد جدول عمل العيادات
          </p>
        </div>
        {tab === "schedule" && (
          <Button
            variant="outline"
            onClick={copyScheduleLink}
            className="border-[#655dc6]/40 text-[#655dc6] hover:bg-[#FAF9FE] gap-2"
            data-testid="copy-schedule-link"
          >
            <Copy className="w-4 h-4" />
            نسخ الرابط العام
          </Button>
        )}
      </div>

      <Tabs value={tab} onValueChange={setTab} dir="rtl" className="space-y-4">
        <TabsList className="grid grid-cols-3 w-full max-w-2xl">
          <TabsTrigger value="manage" className="gap-2" data-testid="tab-manage-doctors">
            <UserCog className="w-4 h-4" />
            الأطباء والأقسام
          </TabsTrigger>
          <TabsTrigger value="pricing" className="gap-2" data-testid="tab-doctor-pricing">
            <Tag className="w-4 h-4" />
            أسعار الخدمات
          </TabsTrigger>
          <TabsTrigger value="schedule" className="gap-2" data-testid="tab-clinic-schedule">
            <CalendarDays className="w-4 h-4" />
            جدول الأطباء
          </TabsTrigger>
        </TabsList>

        <TabsContent value="manage" className="mt-4">
          <DoctorsManagement embedded />
        </TabsContent>

        <TabsContent value="pricing" className="mt-4">
          <DoctorPricing embedded />
        </TabsContent>

        <TabsContent value="schedule" className="mt-4">
          <ClinicSchedule />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default DoctorsHub;
